import React from 'react';
import PropTypes from 'prop-types';
import tw, {styled} from 'twin.macro';
import FormGroup from 'components/FormGroup';
import Select, {Option} from 'components/Select';
import {useTeamMembers} from '../providers/TeamMembersProvider';

TaskOwnerCellPopover.propTypes = {
  taskOwners: PropTypes.arrayOf(PropTypes.shape({
    personId: PropTypes.number,
  })),
  onUpdateItem: PropTypes.func.isRequired,
};

function TaskOwnerCellPopover (props) {
  const {
    taskOwners,
    onUpdateItem,
  } = props;

  const {teamMembers} = useTeamMembers();

  const initialTaskOwnerIds = taskOwners.map(({id}) => id);

  const handleUpdate = (value) => {
    const taskOwnerIds = value.map((idStr) => parseInt(idStr, 10));

    onUpdateItem({
      // Note: We pass up alll the taskOwner details to the
      // useUpdateItemMutation (rather than just the taskOwner ids) as it
      // makes optimistic updates simpler :)
      taskOwners: taskOwnerIds.map((teamMemberId) => teamMembers.find(({user}) => user.id === teamMemberId)).map((teamMember) => ({
        id: teamMember.user.id,
        name: teamMember.user.name,
        email: teamMember.user.email,
      })),
    });
  };

  return (
    <Wrapper>
      <FormGroup top>
        <Select
          mode='multiple'
          placeholder='Please select'
          defaultValue={initialTaskOwnerIds}
          optionFilterProp='label'
          onChange={handleUpdate}
          focusAfterMount
          getPopupContainer={(triggerNode) => triggerNode.parentElement}
          inline
          popupClassName='ant-select-dropdown__fixed'
        >
          {teamMembers.map(({user}) => (
            <Option key={user.id} value={user.id} label={user.name}>{user.name}</Option>
          ))}
        </Select>
      </FormGroup>
    </Wrapper>
  );
}

const Wrapper = styled.div((props) => [
  tw`
    w-72
    mb--8
  `,
]);

export default TaskOwnerCellPopover;
